import { FC } from 'react';
import Markdown from 'react-markdown';

const components = {
    p: ({ children }: any) => <div className="text-grayscale-600 my-4 first:mt-0 last:mb-0">{children}</div>,
    a: ({ href, children }: any) => (
        <a href={href} className="text-grayscale-600 underline" target="_blank" rel="noopener noreferrer">
            {children}
        </a>
    ),
    code: ({ inline, children }: any) =>
        inline ? (
            <code className="text-grayscale-600 bg-grayscaletext-grayscale-600/20 px-1 my-4 rounded">{children}</code>
        ) : (
            <pre className="bg-grayscaletext-grayscale-600/20 text-grayscale-600 p-2 rounded overflow-x-auto my-4">
                <code>{children}</code>
            </pre>
        ),
    ul: ({ children }: any) => <ul className="list-disc my-4 pl-4">{children}</ul>,
    ol: ({ children }: any) => <ol className="list-decimal my-4 pl-4">{children}</ol>,
    li: ({ children }: any) => <li className="text-grayscale-600 my-2">{children}</li>,
    strong: ({ children }: any) => <strong className="text-grayscale-600 font-semibold">{children}</strong>,
};

interface MarkdownViewProps {
    message: string;
}
const MarkdownView: FC<MarkdownViewProps> = (props) => {
    const { message } = props;

    return <Markdown components={components}>{message}</Markdown>;
};

export default MarkdownView;
